import classNames from 'classnames';
import { ReactNode } from 'react';
import { CloseIcon } from '../icons';

export interface BannerProps {
  className?: string;
  contentClassName?: string;
  children: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
}

export const Banner = ({
  className,
  contentClassName,
  children,
  onClose,
  closeLabel = 'Close banner',
}: BannerProps) => {
  return (
    <div
      className={classNames(
        'relative flex min-h-[64px] w-full items-center justify-center border-b border-[#E7D97C] bg-[#FFF6BF] px-12 py-3 sm:min-h-[72px] sm:px-16',
        className,
      )}
    >
      <div
        className={classNames(
          'mx-auto max-w-[1100px] whitespace-normal text-center text-sm leading-6 text-[#5F5413] sm:text-[15px]',
          contentClassName,
        )}
      >
        {children}
      </div>
      {onClose && (
        <button
          type="button"
          aria-label={closeLabel}
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 transition hover:bg-[#F2E79D] sm:right-4"
          onClick={onClose}
        >
          <img src={CloseIcon} alt="Close" className="h-4 w-4 min-w-4 opacity-70" />
        </button>
      )}
    </div>
  );
};
